{
	"accounts": "Kontoer",
	"invitations": "Invitasjoner",
	"subscribeToFeedback": "Abonner på tilbakemeldingsprogram",
	"notificationSettings": {
		"title": "Innstillinger for e-postvarsler",
		"invoicingInformation": "Faktureringsinformasjon",
		"declarationProcessingStatus": "Status for deklarasjonsbehandling",
		"enabled": "På",
		"disabled": "Av",
		"toast": {
			"success": "Varslingsinnstilling oppdatert",
			"error": "Kunne ikke oppdatere varslingsinnstilling"
		}
	},
	"about": {
		"title": "Om",
		"termsAndConditions": "Vilkår og betingelser",
		"privacyPolicy": "Personvernerklæring",
		"imprint": "Avtrykk",
		"openSourceAttribution": "Åpen kildekode-attribusjon"
	},
	"language": {
		"title": "Språk",
		"footer": "Språkendringer vil forplante seg til alle Heidelberg Materials-applikasjoner"
	},
	"impressum": "Avtrykk",
	"copyright": "© 2024 Heidelberg Materials. Alle rettigheter forbeholdt.",
	"login": "Logg inn",
	"logout": "Logg ut"
}
